import { Trans } from 'react-i18next';
import { PricingPackagesTotalPrice } from '../../../../../store/features/packages/types';
import { MuiBox } from '../../../../../../../modules/material';
import Typography, { TypographyProps } from '../../../../library/Typography';

import { StyledTotalRow } from './styles';

export interface SummaryTotalsProps {
  totalPrice: PricingPackagesTotalPrice;
  titleVariant?: TypographyProps['variant'];
}
export default function SummaryTotals(props: SummaryTotalsProps) {
  const {
    totalPrice: {
      subtotal = '',
      taxLabel = '',
      vatRate,
      totalVat,
      totalInclVat,
      displayPriceWithVat,
    },
    titleVariant,
  } = props;

  return (
    <MuiBox className="informa-payment-summary-totals">
      {subtotal && (
        <StyledTotalRow>
          <Typography
            variant={titleVariant}
            className="informa-payment-summary-totals__subtotal-title"
          >
            <Trans i18nKey="site.pricing.order-summary.total-subtotal.label" />
          </Typography>
          <Typography
            variant="featuredText"
            className="informa-payment-summary-totals__subtotal"
          >
            {subtotal}
          </Typography>
        </StyledTotalRow>
      )}
      <StyledTotalRow>
        <Typography
          variant={titleVariant}
          className="informa-payment-summary-totals__vat-rate"
        >
          <Trans
            i18nKey={`site.pricing.order-summary.total-${taxLabel.toLowerCase()}${
              displayPriceWithVat ? '.incl' : ''
            }.label`}
            values={{ 0: vatRate }}
          />
        </Typography>
        <Typography className="informa-payment-summary-totals__total-vat">
          {totalVat}
        </Typography>
      </StyledTotalRow>
      <StyledTotalRow>
        <Typography
          variant={titleVariant}
          className="informa-payment-summary-totals__total-title"
        >
          <Trans i18nKey="site.pricing.order-summary.total-total.label" />
        </Typography>
        <Typography
          variant="h4"
          className="informa-payment-summary-totals__total-incl-vat"
        >
          {totalInclVat}
        </Typography>
      </StyledTotalRow>
    </MuiBox>
  );
}
